<script setup lang="ts">
// 50px capsule in the brand colour (primary), grey fill (secondary) or text link (plain), as in
// the access prototype. The colours come from AccessPage's --brand / --brand-link variables.
withDefaults(
  defineProps<{ variant?: 'primary' | 'secondary' | 'link'; type?: 'button' | 'submit'; busy?: boolean; disabled?: boolean }>(),
  { variant: 'primary', type: 'button' },
)
defineEmits<{ click: [event: MouseEvent] }>()
</script>

<template>
  <button :type="type" class="abtn" :class="`abtn--${variant}`" :disabled="disabled || busy" :aria-busy="busy || undefined" @click="$emit('click', $event)">
    <span v-if="busy" aria-hidden="true" class="abtn__spinner"></span>
    <span><slot /></span>
  </button>
</template>

<style scoped>
.abtn {
  border: none;
  cursor: pointer;
  font-family: var(--font-sans);
  font-weight: var(--weight-medium);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition:
    opacity 150ms,
    background 150ms;
}
.abtn:disabled {
  opacity: 0.5;
  cursor: default;
}
.abtn--primary,
.abtn--secondary {
  height: var(--control-height);
  width: 100%;
  border-radius: var(--radius-control);
  font-size: var(--type-body-size);
}
.abtn--primary {
  background: var(--brand);
  color: var(--on-brand);
}
.abtn--primary:hover:not(:disabled) {
  opacity: 0.86;
}
.abtn--secondary {
  background: var(--surface-card);
  border: 1px solid var(--opaque-separator);
  color: var(--text-secondary);
}
.abtn--secondary:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}
.abtn--link {
  min-height: 36px;
  padding: 0 12px;
  background: transparent;
  color: var(--text-secondary);
  font-size: var(--type-body-size);
}
.abtn--link:hover:not(:disabled) {
  color: var(--text-primary);
}
.abtn__spinner {
  width: 14px;
  height: 14px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: aub-spin 0.8s linear infinite;
}
</style>
